import { JSONSchema7 } from 'json-schema';
import ref from 'fulogics-ui-web/dist/layout/schema/ref';
import UserModelSimpleTextSchema from 'fulogics-ui-web/dist/layout/components/user-model-simple-text/UserModelSimpleTextSchema';

const StateOrderSimpleTextSchema = async () => {
    let schema: JSONSchema7 = {
        title: 'EditedBySimpleTextSchema',
        type: 'object',
        definitions: {},
    };

    schema = {
        properties: {
            className: {
                type: 'string',
            },
            inline: {
                type: 'boolean',
            },
            statusAsTag: {
                type: 'boolean',
            },
            showDeadlineInfo: {
                type: 'boolean',
            },
            // userModelSimpleTextDisplayOptions: {
            //     ...(await ref(schema, UserModelSimpleTextSchema)),
            // },
        },
        ...schema,
    };

    return schema;
};

export default StateOrderSimpleTextSchema;
